import React, { ReactElement, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LoginForm from 'components/organisms/LoginForm';
import useUser from 'hooks/useUser';
import { Typography } from '@material-ui/core';
import { ROLE_DROPSHIPPER } from 'constants/roleType';
import useUserRole from 'hooks/useUserRole';

export default function Login(): ReactElement {
  const history = useHistory();
  const userRole = useUserRole();
  const { isLogged, user } = useUser();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isDemo = params.get('_bt');

  useEffect(() => {
    if (isLogged) {
      if (user) {
        if (userRole === ROLE_DROPSHIPPER) {
          history.push('/admin/orders');
        } else {
          history.push('/admin/purchaseOrders');
        }
      }
    }
  }, [isLogged]);
  return (
    <React.Fragment>
      <LoginForm />
      {isDemo && (
        <Typography variant="subtitle1" align="center" style={{ marginTop: 30 }}>
          Para propositos de demostración usar el usuario demo@demo.com y la contraseña demo123456
        </Typography>
      )}
    </React.Fragment>
  );
}
